<div
	data-cy="error-page"
	class="flex h-screen w-screen items-center justify-center overflow-hidden bg-white px-6 dark:bg-secondary-900 bg-[url('/assets/images/bg-error.svg')] md:bg-contain bg-bottom bg-no-repeat dark:bg-radial"
>
	<div class="flex flex-col items-center justify-center gap-8 md:flex-row md:gap-12">
		<div class="flex flex-col items-center text-center">
			<span class="md:text-9xl text-8xl font-semibold leading-none">
				{{ code() }}
			</span>
			<span class="mt-4 text-4xl font-semibold">
				{{ 'errorPage.' + variant() + '.title' | translate }}
			</span>
			<p class="mt-2 max-w-md md:text-2xl">
				{{ 'errorPage.' + variant() + '.description' | translate }}
			</p>
			<div class="pt-8 flex w-full max-w-xs flex-col gap-2">
				@if (variant() === 'server') {
					<ui-button
						[fullWidth]="true"
						[text]="'errorPage.tryAgain' | translate"
						icon="load_backward"
						(buttonClicked)="retry()"
					></ui-button>
				}
				@if (variant() === 'forbidden') {
					<ui-button
						[fullWidth]="true"
						[text]="'errorPage.logout' | translate"
						(buttonClicked)="logout.emit()"
					></ui-button>
				}
				<ui-button
					[type]="supportButtonType()"
					[fullWidth]="true"
					[text]="'errorPage.contactSupport' | translate"
					[href]="supportHref()"
					icon="message"
				></ui-button>
			</div>
		</div>
		<img
			class="order-first w-full max-w-md xl:max-w-xl md:order-none"
			src="assets/images/agi.png"
			alt="Agilox OFL"
		/>
	</div>
</div>
